"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  letter-spacing: 0;\n  font-weight: 600;\n  text-decoration: none;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var StyledLink = styled_components_1["default"].a(_templateObject(), function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  if (color) return styled_components_1.css(_templateObject2(), color);
  return styled_components_1.css(_templateObject3(), theme.palette.primary.text);
});
/**
 * Link component - Standard anchor <a> tag
 *
 * @param props.children Child components
 * @param props.href Sets href
 * @param props.newTab Open link in new tab
 * @param props.color Set css scolor or link
 * @param props.ReactComponent Set react component to use instead of <a>
 */

var Link = function Link(props) {
  var children = props.children,
      _props$href = props.href,
      href = _props$href === void 0 ? "#" : _props$href,
      _props$newTab = props.newTab,
      newTab = _props$newTab === void 0 ? false : _props$newTab,
      _props$color = props.color,
      color = _props$color === void 0 ? undefined : _props$color,
      _props$ReactComponent = props.ReactComponent,
      ReactComponent = _props$ReactComponent === void 0 ? undefined : _props$ReactComponent,
      rest = __rest(props, ["children", "href", "newTab", "color", "ReactComponent"]);

  var targets = newTab ? {
    target: "_blank",
    rel: "noopenner noreferrer"
  } : undefined;
  var linkColor = color ? {
    color: color
  } : undefined;
  var linkHref = {
    href: href
  };
  if (typeof ReactComponent !== "undefined") return react_1["default"].createElement(ReactComponent, Object.assign({}, props));
  return react_1["default"].createElement(StyledLink, Object.assign({}, linkHref, linkColor, targets, rest), children);
};

exports["default"] = Link;